import styled from "styled-components";


export const VersionListContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};  
  border: 1px solid ${(props) => props.theme.colors.clearGray};
	font-family: ${(props) => props.theme.fonts.family.inter};	
  border-radius: 8px;  
  min-width: 185px;
  max-width: 216px;  
  display: flex;
  flex-direction: column;
	padding: 16px 12px;	
	gap: 16px;
`;

export const VersionListCardContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: 8px;
	min-height: 61px;	
`;

export const VersionListCardNote = styled.div`
  display: flex;
	flex-direction: row;	
	align-items: center;
	justify-content: flex-start;
	border-radius: 8px;
	padding: 4px;	
	height: 28px;
	background-color: ${(props) => props.theme.colors.titanWhite};
	color: ${(props) => props.theme.colors.black};
`;